<template>
  <div>
    <mrc_ess_table v-if="$route.name == 'staffLeave'" :headers="headers" :hideAddBtn="!hasBtn('add-staff-termination')"
      pageName="addStaffLeave" :paginationOptions="options" @turnPage="getlist" :isLoading="loading" :slotKey="[
        'name',
        'change_effective',
        'result_status',
        'termination_reason',
      ]" :items="desserts">
      <template v-slot:search>
        <v-row class="d-flex justify-end" style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px">
          <mrc_ess_advanceFilterAndSearchInput class="mt-4" v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })" :systemFieldMeta="systemFieldMeta"></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template v-slot:item.name="{ item }">
        <mrc_ess_staffListView :staffObj="item"> </mrc_ess_staffListView>
      </template>
      <template v-slot:item.change_effective="{ item }">
        {{ item.change_effective | changeDate() }}
      </template>
      <template v-slot:item.termination_reason="{ item }">
        {{ INT(item.termination_reason) }}
      </template>
      <!-- 状态 -->
      <template v-slot:item.result_status="{ item }">
        <v-chip rounded color="grey" small class="white--text" v-if="item.result_status == 0">{{ $t("label_Unchanged")
        }}</v-chip>
        <v-chip rounded color="#18A874" small class="white--text" v-if="item.result_status == 1">{{ $t("label_Complete")
        }}</v-chip>
        <v-chip rounded color="#18A874" small class="white--text" v-if="item.result_status == 2">{{
          $t("label_The_task_processing_is_complete") }}
        </v-chip>
      </template>

      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <menu-list :list="[
          {
            name: $t('label_View'),
            show: hasBtn('view-staff-termination'),
            type: 'view',
          },
          {
            name: $t('label_Edit'),
            show: hasBtn('edit-staff-termination') && item.result_status == 0,
            type: 'edit',
          },
          {
            name: $t('label_delete'),
            show:
              hasBtn('delete-staff-termination') && item.result_status == 0,
            type: 'del',
          },
        ]" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon v-btnAuth="[
              'view-staff-termination',
              'edit-staff-termination',
              'delete-staff-termination',
            ]">mdi-dots-vertical</v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { getBusinessList } from "@/service/api/prompt.js"
import { getStaffListForFilter } from "@/service/api/autoComplete.js"
import {
  getStaffLeaveList,
  addStaffLeave,
  updateStaffLeave,
  deleteStaffLeave,
  detailStaffLeave,
  getallList,
} from "@/service/api/staffmsg.js"
// import {
//   loginOut
// } from '@/service/api/login.js'
import Cookie from "js-cookie"
import {
  uploadFileAll,
  uploadFileUser,
  uploadFileOrg,
} from "@/service/api/upload.js"
export default {
  components: {},
  props: {},
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      select_arr: [],
      disabled: true,
      list: {},
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      allList: [],
      loading: false,
      desserts: [],
    }
  },
  computed: {
    complete_probation() {
      return {
        prompt_name: "complete_probation",
        org_level_uuid: this.$store.state.currentCompany,
      }
    },
    // menulist () {
    //   return [
    //     {
    //       name: this.$t('label_View'),
    //       show: this.hasBtn('view-staff-termination'),
    //       type: 'view',
    //     },
    //     {
    //       name: this.$t('label_Edit'),
    //       show: this.hasBtn('edit-staff-termination'),
    //       type: 'edit',
    //     },
    //     {
    //       name: this.$t('label_delete'),
    //       show: this.hasBtn('delete-staff-termination'),
    //       type: 'del',
    //     },
    //   ]
    // },
    headers() {
      return [
        {
          text: this.$t("label_Transfer_personnel"),
          align: "start",
          value: "name",
          sortable: false,
        },
        {
          text: this.$t("label_Reason_for_separation"),
          value: "termination_reason",
          sortable: false,
        },
        {
          text: this.$t("label_The_effective_date"),
          value: "change_effective",
          sortable: false,
        },
        {
          text: this.$t("label_The_execution_status"),
          value: "result_status",
          sortable: false,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ]
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  async created() {
    await this.getBtnPermissionList()
  },
  watch: {
    $route(v) {
      if (v.name == "staffLeave") {
        this.getlist()
      }
    },
  },
  async mounted() {
    // this.$getDictName({ dict_name: 'reason_for_resignation' }).then(res => {
    //   if (res.code == 200) {
    //     this.select_arr = res.data
    //   }
    // })
    this.loading = true
    // await this.getdropDownList()
    await this.getlist()
    this.loading = false
  },
  beforeDestroy() {
    this.$ls.remove("staffList")
  },
  methods: {
    async getdropDownList() {
      const res = await getallList({
        org_level_uuid: this.$store.state.currentCompany,
      })
      // const res = await getBusinessList(this.complete_probation)
      // const res = await getStaffListForFilter({
      //   org_level_uuid: this.$store.state.currentCompany,
      // })
      if (res.code == 200) {
        this.allList = res.data
      }
    },
    async getlist(obj) {
      this.loading = true
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--
      if (obj) {
        const { cpage, pagesize } = obj
        this.options = { ...this.options, ...obj }
      }
      const res = await getStaffLeaveList({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if (res.code == 200) {
        this.desserts = res.data
        this.options.totalcount = res.totalcount
        this.options.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
        this.field_alias_name = res.field_alias_name
        this.table_alias_name = res.table_alias_name
      }
      this.loading = false
    },
    addStaffLeave() {
      this.$store.commit("set_subPage_name", "")
      this.$store.commit("set_uuid", "")
      this.$store.commit("set_listObj", {}) //保存这条数据
      this.$store.commit("set_iconstatus", "") //行内进图标显示
      this.$router.push({
        name: "addStaffLeave",
      })
    },
    godetail(item) {
      this.$store.commit("set_iconstatus", true) //行内进图标显示
      this.$store.commit("set_listObj", item) //保存这条数据
      // this.$store.commit('set_subPage_name', item.job_name)
      this.$store.commit("set_uuid", item.uuid) //
      this.$router.push({
        name: "detailStaffLeave",
      })
    },
    handleClick({ item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj)
          break
        case "edit":
          // this.$store.commit('set_subPage_name', obj.job_name)
          this.$store.commit("set_listObj", obj) //保存这条数据
          this.$store.commit("set_iconstatus", false) //行内进图标显示
          this.$store.commit("set_uuid", obj.uuid) //
          this.$router.push({
            name: "detailStaffLeave",
          })
          break
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            deleteStaffLeave({ uuid: obj.uuid }).then((res) => {
              if (res.code == 200) {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                })
                if (this.desserts.length == 1) this.options.cpage--
                this.getlist()
              }
            })
          })
          break
      }
    },
    success() { },
    cancel() { },
  },
}
</script>

<style scoped>
.cardtitle {
  position: relative;
}

.emailbtn {
  position: absolute;
  right: 70px;
  top: -50px;
}

.dowanTemplate {
  position: absolute;
  right: 180px;
  top: -50px;
}
</style>
